<template>
	<div class="parent-video">
		<video-player :options="videoOptions" v-if="showVideo" />
		<div class="current-video">
			<div
				class="cover-image"
				v-if="!showVideo"
				:style="{
					'background-image': 'url(' + currentVideo.thumbnail.large + ')',
				}"
			>
				<div class="gradient-div"></div>
			</div>
			<div class="video-card">
				<h1 class="no-playback">Playback is currently Not available</h1>
				<div class="title">
					<h1>{{ currentVideo.name }}</h1>
				</div>
				<p>{{ currentVideo.description }}</p>
			</div>
		</div>
		<div class="recent-carousel">
			<Category
				v-if="showcatalouge"
				title="You may also like.."
				:api-options="currentCat"
			/>
		</div>
	</div>
</template>

<script>
import VideoPlayer from "@/pages/VideoPlayer.vue";
import Category from "@/components/Category.vue";

export default {
	name: "VideoScreen",
	components: {
		Category,
		VideoPlayer,
	},
	data() {
		return {
			dummyURLs: {
				mp4:
					"http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
				live:
					"http://replays.robertsstream.com/racereplays/cust/gemshopping/roku.m3u8",
				youtube: "http://www.youtube.com/watch?v=LXb3EKWsInQ",
			},
			showCover: false,
			category_data: {},
			showVideo: false,
			currentVideo: {},
			currentCat: null,
			player: null,
			showcatalouge: false,
			videoOptions: {
				hls: {
					withCredentials: true,
				},
				autoplay: false,
				controls: true,
				sources: [
					{
						src: "https://www.youtube.com/watch?v=8zUskBLreUY",
						type: "video/youtube",
					},
				],
			},
		};
	},
	beforeCreate() {
		this.$store.commit("setLoader", true);
		this.$store.dispatch("getVideoById", this.$route.params.vid).then((res) => {
			this.currentVideo = res._embedded.collections[0];
			this.showVideo = false;
			// this.getPlayback();
		});
	},
	created() {
		this.currentCat = this.$route.params.catid;
		if (this.currentCat) {
			this.showcatalouge = true;
		}

		this.$store.commit("setLoader", true);
		this.$store
			.dispatch("getVideoPlaybackURL", this.currentVideo._links.files.href)
			.then((res) => {
				if (res) {
					var playbackurl = res.response.url;
					if (playbackurl.indexOf("mp4") == -1) {
						videoOptions = {
							hls: {
								withCredentials: true,
							},
							autoplay: false,
							controls: true,
							sources: [
								{
									src: playbackurl,
									type: "video/mp4",
								},
							],
						};

						this.$store.commit("setLoader", false);
						this.showVideo = true;
					} else if (playbackurl.indexOf("youtube") == -1) {
						videoOptions = {
							hls: {
								withCredentials: true,
							},
							autoplay: false,
							controls: true,
							sources: [
								{
									src: playbackurl,
									type: "video/youtube",
								},
							],
						};

						this.$store.commit("setLoader", false);
						this.showVideo = true;
					} else if (playbackurl.indexOf("m3u8") == -1) {
						videoOptions = {
							hls: {
								withCredentials: true,
							},
							autoplay: false,
							controls: true,
							sources: [
								{
									src: playbackurl,
									type: "application/x-mpegURL",
								},
							],
						};

						this.$store.commit("setLoader", false);
						this.showVideo = true;
					}
				} else {
					this.$store.commit("setLoader", false);
					this.showVideo = false;
				}
			})
			.catch((err) => {
				this.$store.commit("setLoader", false);
			});
	},
	methods: {},
};
</script>
<style scoped>
.current-video {
	width: 100%;
	text-shadow: 1px 1px 5px #333;
}
.parent-video {
	width: 90%;
	margin: 0 auto;
	min-width: 90%;
	margin-top: 70px;
	text-shadow: 1px 1px 5px #333;
}
.no-playback {
	color: red;
	text-shadow: 1px 1px 5px #333;
}
.cover-image {
	position: relative;
	width: 100%;
	min-height: 100vh;
	background-size: cover;
	border-bottom: 1px solid #000;
	opacity: 0.9;
	margin-bottom: -250px;
}
.video-card {
	position: relative;
	z-index: 5000;
	background-color: #000000;
	width: 80%;
	margin: 0 auto;
	color: #ffff;
	padding: 20px;
	margin-top: 16px;
	/*box-shadow: 0px 1px 10px 11px rgba(88, 86, 86, 0.5);*/
}
.video-card p {
	margin-bottom: 40px;
}
.recent-carousel {
	margin: 0 auto;
	width: 80%;
	position: relative;
	padding-top: 100px;
}
.gradient-div {
	position: absolute;
	width: 100%;
	bottom: 0px;
	border: 5px solid rgb(0, 0, 0);
	box-shadow: 0px -20px 50px 50px rgb(0, 0, 0);
}
@media only screen and (max-width: 600px) {
	.cover-image {
		min-height: 50vh;
	}
	.video-card {
		background-color: #000000;
		width: 90%;
	}
}
</style>
